import { Component, Injector, OnInit } from '@angular/core';
import { Validators, AbstractControl } from '@angular/forms';
import { BaseComponent } from 'src/app/common/base/base.component';
import { Configuration } from 'src/app/common/enumerations/enumerations';
import { SiteConfiguration } from 'src/app/components/site-configuration/site-configuration';
import { SiteConfigurationService } from 'src/app/components/site-configuration/site-configuration.service';

@Component({
  selector: 'scf-v2-settings-notifications',
  templateUrl: './scf-v2-settings-notifications.component.html',
  styleUrls: ['./scf-v2-settings-notifications.component.scss']
})
export class ScfV2SettingsNotificationsComponent extends BaseComponent implements OnInit {

  loading = false;
  siteConfiguration!: SiteConfiguration[];

  public get notificationActiveCtrl(): AbstractControl | null { return this.formGroup.get('notificationActiveCtrl'); }
  public get notificationEmailsCtrl(): AbstractControl | null { return this.formGroup.get('notificationEmailsCtrl'); }
  public get notificationHPEmailsCtrl(): AbstractControl | null { return this.formGroup.get('notificationHPEmailsCtrl'); }
  public get notificationRPEmailsCtrl(): AbstractControl | null { return this.formGroup.get('notificationRPEmailsCtrl'); }

  constructor(
    public siteConfService: SiteConfigurationService,
    protected override injector: Injector
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.buildform();
    this.loadSiteConfiguration();
  }

  buildform() {
    this.formGroup = this.formBuilder.group({
      notificationActiveCtrl: [null, Validators.required],
      notificationEmailsCtrl: [null, Validators.pattern(/^([\w+-.%]+@[\w-.]+\.[A-Za-z]{2,4}(,\s)?)+$/)],
      notificationHPEmailsCtrl: [null, Validators.pattern(/^([\w+-.%]+@[\w-.]+\.[A-Za-z]{2,4}(,\s)?)+$/)],
      notificationRPEmailsCtrl: [null, Validators.pattern(/^([\w+-.%]+@[\w-.]+\.[A-Za-z]{2,4}(,\s)?)+$/)],
    });
  }

  loadSiteConfiguration() {
    this.loading = true;
    this.siteConfService.getAll().toPromise().then(data => {
      if (data) {
        this.siteConfiguration = data;
        this.loading = false;
        this.notificationActiveCtrl?.setValue(this.siteConfiguration.find(x => x.id == Configuration.SCFNotifications)?.value == "True");
        this.notificationEmailsCtrl?.setValue(this.siteConfiguration.find(x => x.id == Configuration.SCFEmails));
        this.notificationHPEmailsCtrl?.setValue(this.siteConfiguration.find(x => x.id == Configuration.SCFHPEmails));
        this.notificationRPEmailsCtrl?.setValue(this.siteConfiguration.find(x => x.id == Configuration.SCFRPEmails));
        this.checkDisabled();
      }
    });
  }

  checkDisabled() {
    if (this.siteConfiguration.find(x => x.id == Configuration.SCFNotifications)?.value == "True") {
      this.notificationEmailsCtrl?.enable();
    }
    else {
      this.notificationEmailsCtrl?.disable();
    }
  }

  override getErrorMsg(control: AbstractControl | null): string | null {
    if (control)
      if (control.hasError('pattern')) { return 'Invalid email Addresses'; }
    return null;
  }

  activeToggleChanged(e: any) {
    this.siteConfiguration.find(x => x.id == Configuration.SCFNotifications)!.value = e.checked;
    this.checkDisabled();
    this.save();
  }

  emailsChanged(type: number, e: any) {
    switch (type) {
      case 0:
        this.siteConfiguration.find(x => x.id == Configuration.SCFEmails)!.value = e.target.value;
        break;
      case 1:
        this.siteConfiguration.find(x => x.id == Configuration.SCFHPEmails)!.value = e.target.value;
        break;
      case 2:
        this.siteConfiguration.find(x => x.id == Configuration.SCFRPEmails)!.value = e.target.value;
        break;
    }

    if (this.formGroup.valid) {
      this.save();
    }
  }

  getHint(type: number) {
    switch (type) {
      case 0:
        return this.getMessage('SCFEmailNotificationslAll').description;
        break;
      case 1:
        return this.getMessage('SCFEmailNotificationslHP').description;
        break;
      case 2:
        return this.getMessage('SCFEmailNotificationslRP').description;
        break;
    }
    return '';
  }

  save() {
    const saveConfigs = this.siteConfiguration.map(c => {
      return { id: c.id, value: c.value?.toString() ?? '' };
    });
    this.siteConfService.updateAll(saveConfigs).toPromise().then(() => {
      this.alert.success('Configuration Saved!');
    });
  }
}
